import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button/unstyled-button';

export const StyledBodyDialog = styled.div`
  padding: 1em;
  margin-bottom: 1em;
`;

export const TextDialog = styled.div`
  margin-bottom: 1em;
`;

export const OkayDialogButton = styled(UnstyledButton)`
  float: right;
`;
